// extracted by mini-css-extract-plugin
export default {"top":"AuthTop_top__G2Izl"};